const hasActivePromotion = (promotionName, obj) => {
  if (obj && obj.promotions && obj.promotions.length > 0) {
    return (
      obj.promotions.findIndex(
        f => f.promotionType == promotionName && f.active,
      ) > -1
    )
  }
  return false
}

const getEndDateForPromotion = (promotionName, obj) => {
  if (obj && obj.promotions && obj.promotions.length > 0) {
    const item = obj.promotions.find(
      f => f.promotionType == promotionName && f.active && f.to,
    )
    if (item) {
      return new Date(item.to)
    }
  }
  return null
}

const getEndDateForPromotionOnly = (promotionName, promotions) => {
  if (promotions && promotions.length > 0) {
    const item = promotions.find(f => f.type == promotionName)
    if (item) {
      return new Date(item.to)
    }
  }
  return null
}

const hasAnyPromotion = obj => {
  return obj.promotions.length > 0
}

const count = obj => {
  return obj.promotions.length
}

const getFirstEnddateOfPromotions = promotions => {
  let activePromotions = promotions.filter(promotion => {
    return promotion.active
  })

  if (activePromotions.length > 0) {
    let earliestDate = activePromotions.reduce(function(prev, curr) {
      return prev.to < curr.to ? prev : curr
    })

    return new Date(earliestDate.to)
  } else {
    return false
  }
}

const hasAnyActivePromotion = promotions => {
  let activePromotions = promotions.filter(promotion => {
    return promotion.active
  })

  return activePromotions.length > 0
}

export default {
  hasActivePromotion,
  getEndDateForPromotion,
  getEndDateForPromotionOnly,
  hasAnyPromotion,
  hasAnyActivePromotion,
  count,
  getFirstEnddateOfPromotions,
}
